import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SafeIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SafeIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.432 2.08789H6.36753C5.18968 2.08789 4.23145 3.04616 4.23145 4.22401V17.2884C4.23145 18.2649 4.89037 19.0899 5.78672 19.3436V21.3322C5.78672 21.653 6.04677 21.9131 6.36754 21.9131H8.85598C9.17673 21.9131 9.4368 21.653 9.4368 21.3322V19.4246H16.3627V21.3322C16.3627 21.653 16.6228 21.9131 16.9435 21.9131H19.432C19.7528 21.9131 20.0128 21.653 20.0128 21.3322V19.3437C20.9092 19.09 21.5681 18.265 21.5681 17.2885V4.22401C21.5681 3.04616 20.6099 2.08789 19.432 2.08789ZM7.88149 5.738H17.9179V15.7745H7.88149V5.738ZM6.71986 12.6639H5.39308V8.84857H6.71989L6.71986 12.6639ZM8.27513 20.7514H6.94835V19.4246H8.27516L8.27513 20.7514ZM18.8512 20.7514H17.5243V19.4246H18.8512V20.7514ZM20.4065 17.2884C20.4065 17.8258 19.9693 18.2629 19.432 18.2629H6.36753C5.8302 18.2629 5.39308 17.8258 5.39308 17.2884V13.8255H6.71989V16.3553C6.71989 16.676 6.97994 16.9361 7.30071 16.9361H18.4988C18.8195 16.9361 19.0796 16.676 19.0796 16.3553V5.15715C19.0796 4.83639 18.8196 4.57633 18.4988 4.57633H7.30067C6.97991 4.57633 6.71985 4.83638 6.71985 5.15715V7.68695H5.39307V4.22401C5.39307 3.68668 5.83019 3.24952 6.36752 3.24952H19.432C19.9693 3.24952 20.4064 3.68668 20.4064 4.22401L20.4065 17.2884Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.887 8.59039L16.3898 8.0876C16.6166 7.86081 16.6166 7.49304 16.3898 7.26621C16.163 7.03942 15.7952 7.03942 15.5684 7.26621L15.0656 7.769C14.4568 7.32634 13.7083 7.06482 12.8997 7.06482C12.0911 7.06482 11.3426 7.32634 10.7338 7.76896L10.2311 7.26621C10.0043 7.03946 9.63654 7.03942 9.40967 7.26617C9.18288 7.493 9.18284 7.86073 9.40963 8.0876L9.91238 8.59039C9.4698 9.1992 9.20829 9.94768 9.20829 10.7563C9.20829 11.5648 9.4698 12.3133 9.91238 12.9221L9.40963 13.4249C9.18284 13.6518 9.18288 14.0195 9.40967 14.2464C9.52312 14.3598 9.67174 14.4165 9.82036 14.4165C9.96898 14.4165 10.1177 14.3597 10.2311 14.2463L10.7338 13.7436C11.3426 14.1862 12.0911 14.4477 12.8996 14.4477C13.7082 14.4477 14.4568 14.1862 15.0655 13.7436L15.5684 14.2463C15.6818 14.3597 15.8305 14.4164 15.9791 14.4164C16.1277 14.4164 16.2764 14.3597 16.3898 14.2463C16.6166 14.0195 16.6166 13.6517 16.3898 13.4249L15.887 12.9222C16.3296 12.3134 16.5911 11.5648 16.5911 10.7562C16.5911 9.94765 16.3296 9.19912 15.887 8.59039ZM10.37 10.7562C10.37 9.36132 11.5048 8.22645 12.8997 8.22645C14.2946 8.22645 15.4295 9.36132 15.4295 10.7562C15.4295 12.1511 14.2947 13.286 12.8997 13.286C11.5048 13.286 10.37 12.1512 10.37 10.7562Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SafeIcon;
